import { useState, useEffect, useCallback } from 'react';
import PetService from '../services/petService';

function MainView({ petState, onOpenFeed, onOpenFocus, onOpenSettings, onLogout }) {
  const [hungerTime, setHungerTime] = useState({ hours: 0, minutes: 0 });
  const [remainingFocus, setRemainingFocus] = useState(0);

  const updateHungerTime = useCallback(() => {
    if (petState) {
      const time = PetService.getHungerTime(petState);
      setHungerTime(time);
    }
  }, [petState]);

  const updateRemainingFocus = useCallback(() => {
    if (petState) {
      const remaining = PetService.getRemainingFocusTime(petState);
      setRemainingFocus(remaining);
    }
  }, [petState]);

  useEffect(() => {
    if (petState) {
      updateHungerTime();
      updateRemainingFocus();

      const interval = setInterval(() => {
        updateHungerTime();
        updateRemainingFocus();
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [petState, updateHungerTime, updateRemainingFocus]);

  const getAnimalImage = (imagePath) => {
    const imageMap = {
      'bear_img.png': '/images/bear.png',
      'cat_img.png': '/images/cat.png',
      'bunny_img.png': '/images/bunny.png',
      'wolf_img.png': '/images/wolf.png',
    };
    return imageMap[imagePath] || '/images/bear.png';
  };

  if (!petState) {
    return <div>Loading...</div>;
  }

  return (
    <div className="main-view">
      <h1 className="greeting-text">Hi, {petState.username}</h1>
      <p className="subtitle-text">{petState.animalName} missed you</p>

      <img src={getAnimalImage(petState.animalImagePath)} alt="Pet" className="pet-image" />

      <button className="button feed-button" onClick={onOpenFeed}>
        Feed
      </button>

      <p className="goal-text">
        {' '}
        Your daily goal is <span style={{ fontWeight: 'bold' }}>{petState.focusGoal} min</span>
      </p>
      <p className="goal-text">
        Time left <span style={{ fontWeight: 'bold' }}>{remainingFocus} min</span>
      </p>

      <div className="info-container">
        <div className="info-box">
          <div className="info-number">{petState.totalTime}</div>
          <div className="info-label">total min</div>
        </div>
        <div className="info-box">
          <div className="info-number">{petState.totalTimesAte}</div>
          <div className="info-label">times ate</div>
        </div>
      </div>

      <div className="hunger-box">
        <div className="info-number">
          {hungerTime.hours}h {hungerTime.minutes}m
        </div>
        <div className="info-label">will be hungry in</div>
      </div>

      <div className="button-container">
        <button className="button focus-button" onClick={onOpenFocus}>
          Focus now
        </button>
        <button className="button settings-button" onClick={onOpenSettings}>
          <span className="settings-icon">⚙️</span>
        </button>
      </div>

      <button onClick={onLogout} className="logout-button">
        Log out
      </button>
    </div>
  );
}

export default MainView;
